import React from "react";

export function Input({ testId, className = "", ...props }) {
  return (
    <input
      data-testid={testId}
      className={`w-full h-8 px-2 text-[13px] border border-slate-200 rounded-sm bg-white focus:outline-none focus:ring-1 focus:ring-blue-500 ${className}`}
      {...props}
    />
  );
}

export function Textarea({ testId, className = "", ...props }) {
  return (
    <textarea
      data-testid={testId}
      rows={3}
      className={`w-full px-2 py-1.5 text-[13px] border border-slate-200 rounded-sm bg-white focus:outline-none focus:ring-1 focus:ring-blue-500 ${className}`}
      {...props}
    />
  );
}

export function Select({ testId, options = [], labels = null, value, onChange, allowEmpty = true, className = "", disabled = false }) {
  return (
    <select
      data-testid={testId}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`w-full h-8 px-2 text-[13px] border border-slate-200 rounded-sm bg-white focus:outline-none focus:ring-1 focus:ring-blue-500 ${disabled ? "readonly-field cursor-not-allowed" : ""} ${className}`}
    >
      {allowEmpty && <option value="">—</option>}
      {options.map((opt) => (
        <option key={opt} value={opt}>{labels && labels[opt] !== undefined ? labels[opt] : opt}</option>
      ))}
    </select>
  );
}

export function Button({ variant = "default", className = "", testId, children, ...props }) {
  const base = "h-8 text-[12px] font-semibold rounded-sm inline-flex items-center gap-1.5 transition-colors border disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap px-3";
  const variants = {
    default: "bg-white text-slate-800 border-slate-200 hover:bg-slate-50",
    primary: "bg-slate-900 text-white border-slate-900 hover:bg-slate-800",
    danger:  "bg-white text-red-700 border-red-200 hover:bg-red-50",
    success: "bg-emerald-600 text-white border-emerald-600 hover:bg-emerald-700",
    info:    "bg-white text-indigo-700 border-indigo-200 hover:bg-indigo-50",
    accent:  "bg-white text-teal-700 border-teal-200 hover:bg-teal-50",
    purple:  "bg-white text-purple-700 border-purple-200 hover:bg-purple-50",
    ghost:   "bg-transparent border-transparent hover:bg-slate-100 text-slate-700",
  };
  return (
    <button data-testid={testId} className={`${base} ${variants[variant] || variants.default} ${className}`} {...props}>
      {children}
    </button>
  );
}
